import { render } from "./ManualImageCamera.vue?vue&type=template&id=5b9f510a"
import script from "./ManualImageCamera.vue?vue&type=script&lang=js"
export * from "./ManualImageCamera.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__